/**
 * AgentMount — wires React state into the global agent context, then
 * renders the floating chat button. Must be mounted INSIDE both
 * <Router> (uses useLocation) and <WorkflowTourProvider> (uses useTour).
 */
import React from 'react';
import { useTour } from '../tour';
import { getTourSteps } from '../tour/tourSteps';
import { useAgentContextSync } from '../../services/agent/agentContext';
import { AgentChatButton } from './AgentChatButton';

export const AgentMount: React.FC = () => {
  const { isActive, currentStep } = useTour();

  // Derive current step metadata from the same source the tour uses.
  // getTourSteps() reads from i18n; calling it per render is cheap.
  const steps = isActive ? getTourSteps() : [];
  const step = steps[currentStep];

  useAgentContextSync({
    tourActive: isActive,
    tourStepId: step?.id ?? null,
    tourStepIndex: currentStep,
    tourPhase: step?.phase ?? null,
  });

  return <AgentChatButton />;
};

export default AgentMount;
